// extracted by mini-css-extract-plugin
export default {"lds-spinner":"style_lds-spinner__Yy9xS"};